module.exports = __webpack_public_path__ + "img/bul_user_switch.110bd9b4.svg";